export const cssBundleHref = "/build/css-bundle-7FJXUOS7.css";